import {App} from './app';
// import {hot} from 'react-hot-loader';
// export default hot(module)(App);
export default App;
